import type { SetterOrUpdater } from 'recoil';
import type {
  ValidationState,
  FeedbackInputValidationType,
  ValidationField,
} from '~/components/page/LFA/state/validationState';

type ClearValidationArgs = {
  state: ValidationState;
  setState: SetterOrUpdater<ValidationState>;
  key: FeedbackInputValidationType;
  field: ValidationField;
};

const clearError = ({ state, setState, key, field }: ClearValidationArgs) => {
  const newState = new Map(state);
  newState.set(
    key,
    newState.get(key)?.filter(error => error.field !== field) ?? [],
  );
  setState(newState);
};

export default clearError;
